export default {"src":"/_next/static/media/BLK.26bb508d.svg","height":18,"width":18};